import axios from "axios";
import store from "../../redux/store";
import {
  refreshAccessToken,
  getAccessToken,
  getRefreshToken,
  setTokens,
} from "../../redux/thunks/userThunks";
import { logout } from "../../redux";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Attach access token to every request if available
axios.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = getRefreshToken();
        const result = await store.dispatch(refreshAccessToken(refreshToken));
        if (result.payload === undefined && result.error?.payload?.logout) {
          // If refreshAccessToken signals logout, dispatch logout
          store.dispatch(logout());
          // Optionally, clear tokens here as well
          setTokens({ access_token: null, refresh_token: null });
          return Promise.reject(error);
        }
        const newToken = result.payload;

        processQueue(null, newToken);
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    // If refresh token returns 400 anywhere else, force logout
    if (
      error.response?.status === 400 &&
      error.config?.url?.includes("/auth/refresh")
    ) {
      console.log("This");
      store.dispatch(logout());
      setTokens({ access_token: null, refresh_token: null });
      localStorage.removeItem("username");
      sessionStorage.removeItem("username");
      localStorage.removeItem("password");
      sessionStorage.removeItem("password");
    }

    return Promise.reject(error);
  }
);
// ...existing code...
